module.exports = __webpack_public_path__ + "img/medal2.4801be22.png";